import { useMemo } from 'react';
import { GROUPING_OPTIONS, TableStyle } from '../../../types';
import { useTableStyles } from '../report-table.styles';

interface UseAllTableStylesParams {
  headerRowStyle: TableStyle;
  forecastsRowStyle: TableStyle;
  categoriesRowStyle: TableStyle;
  groupsRowStyle: TableStyle;
  accountsRowStyle: TableStyle;
  assumptionsRowStyle: TableStyle;
  formulasRowStyle: TableStyle;
  driverGroupsRowStyle: TableStyle;
  driversRowStyle: TableStyle;
}

export const useAllTableStyles = ({
  headerRowStyle,
  forecastsRowStyle,
  categoriesRowStyle,
  groupsRowStyle,
  accountsRowStyle,
  assumptionsRowStyle,
  formulasRowStyle,
  driverGroupsRowStyle,
  driversRowStyle
}: UseAllTableStylesParams) => {
  const headerStyles = useTableStyles({ style: headerRowStyle });
  const forecastsStyles = useTableStyles({ style: forecastsRowStyle });
  const categoriesStyles = useTableStyles({ style: categoriesRowStyle });
  const groupsStyles = useTableStyles({ style: groupsRowStyle });
  const accountsStyles = useTableStyles({ style: accountsRowStyle });
  const assumptionsStyles = useTableStyles({ style: assumptionsRowStyle });
  const formulasStyles = useTableStyles({ style: formulasRowStyle });
  const driverGroupsStyles = useTableStyles({ style: driverGroupsRowStyle });
  const driversStyles = useTableStyles({ style: driversRowStyle });

  const stylesPerType = useMemo(
    () => ({
      [GROUPING_OPTIONS.CATEGORIES]: categoriesStyles,
      [GROUPING_OPTIONS.GROUPS]: groupsStyles,
      [GROUPING_OPTIONS.ACCOUNTS]: accountsStyles,
      [GROUPING_OPTIONS.ASSUMPTIONS]: assumptionsStyles,
      [GROUPING_OPTIONS.FORMULAS]: formulasStyles,
      [GROUPING_OPTIONS.DRIVER_GROUPS]: driverGroupsStyles,
      [GROUPING_OPTIONS.DRIVERS]: driversStyles
    }),
    [
      categoriesStyles,
      groupsStyles,
      accountsStyles,
      assumptionsStyles,
      formulasStyles,
      driverGroupsStyles,
      driversStyles
    ]
  );

  const rowStylesPerType = useMemo(
    () => ({
      [GROUPING_OPTIONS.CATEGORIES]: categoriesRowStyle,
      [GROUPING_OPTIONS.GROUPS]: groupsRowStyle,
      [GROUPING_OPTIONS.ACCOUNTS]: accountsRowStyle,
      [GROUPING_OPTIONS.ASSUMPTIONS]: assumptionsRowStyle,
      [GROUPING_OPTIONS.FORMULAS]: formulasRowStyle,
      [GROUPING_OPTIONS.DRIVER_GROUPS]: driverGroupsRowStyle,
      [GROUPING_OPTIONS.DRIVERS]: driversRowStyle
    }),
    [
      categoriesRowStyle,
      groupsRowStyle,
      accountsRowStyle,
      assumptionsRowStyle,
      formulasRowStyle,
      driverGroupsRowStyle,
      driversRowStyle
    ]
  );

  return {
    headerStyles,
    forecastsStyles,
    stylesPerType,
    rowStylesPerType
  };
};
